/**
 * 官网栏目的展示口径(1009 二期,纯函数):条目状态人话 / 节奏一句话 / 各状态能做什么。
 */
import type { ColumnItem, ColumnItemStatus, SiteColumn } from "../api/reporterColumnService";

export const COLUMN_ITEM_LABEL: Record<ColumnItemStatus, string> = {
  PENDING: "待生成",
  GENERATING: "生成中",
  REVIEW: "待审",
  CONFIRMED: "已确认",
  PUBLISHED: "已发布",
  FAILED: "失败",
  SKIPPED: "已跳过",
};

const WEEKDAY = ["", "一", "二", "三", "四", "五", "六", "日"];

/** 「每周一、三、五 09:00 · 共 10 篇 · 每天最多 3 篇」 */
export function cadenceText(
  c: Pick<SiteColumn, "weekdays" | "publishTime" | "totalCount" | "endDate" | "dailyLimit">
): string {
  const days = [...c.weekdays].sort((a, b) => a - b);
  const dayText = days.length === 7 ? "每天" : `每周${days.map((d) => WEEKDAY[d]).join("、")}`;
  const parts = [`${dayText} ${c.publishTime}`];
  if (c.totalCount != null) parts.push(`共 ${c.totalCount} 篇`);
  if (c.endDate) parts.push(`到 ${c.endDate}`);
  parts.push(`每天最多 ${c.dailyLimit} 篇`);
  return parts.join(" · ");
}

/** 条目可做的动作。 */
export function itemActions(i: Pick<ColumnItem, "status" | "draftId">): {
  editTopic: boolean;
  remove: boolean;
  generate: boolean;
  review: boolean;
  confirm: boolean;
} {
  const early = i.status === "PENDING" || i.status === "FAILED" || i.status === "SKIPPED";
  return {
    editTopic: early,
    remove: i.status !== "CONFIRMED" && i.status !== "PUBLISHED",
    generate: early,
    review:
      !!i.draftId &&
      (i.status === "REVIEW" || i.status === "CONFIRMED" || i.status === "PUBLISHED"),
    confirm: i.status === "REVIEW",
  };
}

/** `2026-10-14T09:00` → `10-14 周三 09:00`。 */
export function plannedText(t: string): string {
  if (!t || t.length < 16) return t;
  const d = new Date(`${t.slice(0, 10)}T00:00:00`);
  const wd = WEEKDAY[d.getDay() === 0 ? 7 : d.getDay()];
  return `${t.slice(5, 10)} 周${wd} ${t.slice(11, 16)}`;
}

/** react-query 键:栏目列表。 */
export const COLUMNS_KEY = ["reporter-site-columns"] as const;
